import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import TopUrgencyBar from "@/components/TopUrgencyBar";
import Footer from "@/components/Footer";
import InterestForm from "@/components/InterestForm";
import { Users, Lock, Ticket } from "lucide-react";

export default function Register() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialTier = params.get("tier") || "";
  const panelApply = params.get("panel") === "1";

  return (
    <div className="min-h-screen bg-[#FAFAF7]">
      <TopUrgencyBar />
      <Navbar />

      {/* Hero */}
      <header className="relative bg-[#0A1128] text-white overflow-hidden pt-[124px] md:pt-[128px]">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-[#0A1128] via-[#0F1B3D] to-[#0A1128]" />
          <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: "linear-gradient(rgba(255,255,255,.15) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.15) 1px, transparent 1px)", backgroundSize: "60px 60px" }} />
        </div>
        <div className="relative max-w-5xl mx-auto px-6 lg:px-10 py-14 md:py-20 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#FACC15]/10 border border-[#FACC15]/30 text-[#FACC15] rounded-full mb-5 text-[10px] md:text-xs font-black uppercase tracking-[0.25em]">
            <Lock size={11} /> Registration · Step 1 of 2
          </div>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.95] mb-4">
            Lock In Your Spot.
          </h1>
          <p className="text-lg md:text-xl text-white/85 max-w-2xl mx-auto leading-relaxed mb-6">
            Fill out this info once. We&apos;ll save your details, then send you straight to Stripe to complete payment for the ticket you pick.
          </p>
          <div className="inline-flex items-center flex-wrap justify-center gap-2 md:gap-3 text-[10px] md:text-xs font-black uppercase tracking-widest text-white/70">
            <span className="inline-flex items-center gap-1.5 bg-white/5 border border-white/10 rounded-full px-3 py-1.5">
              <span className="w-5 h-5 rounded-full bg-[#0066FF] text-white flex items-center justify-center text-[10px]">1</span>
              Fill out your info
            </span>
            <span className="text-white/30">→</span>
            <span className="inline-flex items-center gap-1.5 bg-white/5 border border-white/10 rounded-full px-3 py-1.5">
              <span className="w-5 h-5 rounded-full bg-[#0066FF] text-white flex items-center justify-center text-[10px]">2</span>
              Pick your ticket
            </span>
            <span className="text-white/30">→</span>
            <span className="inline-flex items-center gap-1.5 bg-white/5 border border-white/10 rounded-full px-3 py-1.5">
              <span className="w-5 h-5 rounded-full bg-[#FACC15] text-[#0A1128] flex items-center justify-center text-[10px]">3</span>
              Pay on Stripe · You&apos;re in
            </span>
          </div>
        </div>
        {/* Angled bottom */}
        <div className="absolute bottom-0 inset-x-0 h-8 bg-[#FAFAF7]" style={{ clipPath: "polygon(0 100%, 100% 100%, 100% 0)" }} />
      </header>

      {/* Form */}
      <main className="max-w-4xl mx-auto px-6 lg:px-10 py-16 md:py-20">
        <InterestForm mode="register" initialTier={initialTier} defaultPanelApply={panelApply} />
      </main>

      <Footer />
    </div>
  );
}
